import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { waveEventsActions } from '../store/modules/waveEvents';
import { ApplicationState } from '../store/types';

export type WithWaveEventsInsertedProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = ({ waveEvents }: ApplicationState) => {
  const {
    dateEvents,
    isPending,
    startWeekDate,
    endWeekDate
  } = waveEvents.waveEventItems;

  const { data: currentWaveEvent } = waveEvents.currentWaveEvent;
  const currentWeekEvents = dateEvents[startWeekDate];

  return {
    startWeekDate,
    endWeekDate,
    currentWaveEvent,
    currentWeekEvents,
    isWaveEventPending: isPending
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  waveEventsActions: bindActionCreators(waveEventsActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
